module.exports = __webpack_public_path__ + "media/application/images/2025/title-1500-503e4cb2af6eb845e483f1b49a7fa222.png";